$.fn.ExtraInfo = function() {
  let self = this
  self.scrollEvents = $(window).ScrollEvents();

  $('.js-open-info').click(function() {
    self.toggleClass('--open-info');
  })

  $('.js-close-info').click(function() {
    self.removeClass('--open-info');
  })

  self.stickInfo = function() {
    if (self.offset().top + self.height() <= $(window).height() + $(window).scrollTop()) {
      self.addClass('--fix-bottom')
    } else {
      self.removeClass('--fix-bottom')
    }

    if ($(window).scrollTop() < self.offset().top - ($(window).height() - self.find('.extra-infos-pop__content').innerHeight())) {
      self.addClass('--fix-top')
    } else {
      self.removeClass('--fix-top')
    }
  }

  return function() {
    self.scrollEvents.add(self.stickInfo)
    return self
  }()
}
